import React, { useContext } from "react";
import { Name } from "../../atoms/name/name"
import { ThemeContext } from "../../../context"

export const Header = () => {
  const context = useContext(ThemeContext)
  return (
    <header>
      <div className="name">
        <h2><Name name={context.imageData.name} /></h2>
      </div>
      <div className="title">
        <h1>10 Principles of
        
         Good Design</h1>
      </div>
    </header>
  );
};
